import { Box, Typography } from '@mui/material';
import React from 'react';

import { RECEIPT_DEVICE_COUNT_THRESHOLD } from '../../constants/lineItems';
import { formatDeviceCountShort } from '../../util/helpers';

// ADOPS-2556: Shared renderer for the Receipts product/category autocomplete options.
// Shows the option's device count in the dropdown, right-aligned and formatted in "k",
// highlighting red below the DS threshold and green at/above. Display only — the count is
// never carried onto the selected chip or saved. Shared between KpiProductSelector and
// KpiProductCategorySelector so the threshold/color/formatting cannot drift apart.
const renderDeviceCountOption = (props, option) => {
  const { key, ...optionProps } = props;
  return (
    <Box
      component="li"
      key={key ?? option.value}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...optionProps}
      sx={{ display: 'flex', justifyContent: 'space-between' }}
    >
      <span>{option.label}</span>
      {typeof option.count === 'number' && (
        <Typography
          component="span"
          variant="body2"
          color={option.count < RECEIPT_DEVICE_COUNT_THRESHOLD ? 'error.main' : 'success.main'}
          sx={{ ml: 'auto', pl: 2, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}
        >
          {formatDeviceCountShort(option.count)}
        </Typography>
      )}
    </Box>
  );
};

export default renderDeviceCountOption;
